import { convertToDisplayEnum, makeConfig } from '.';
import type { DisplayEnum } from './types';

export type CustomPacingRequestedOption = keyof typeof customPacingRequestedOptionDisplayNames;

const customPacingRequestedOptionDisplayNames = {
  DEFAULT: '(if eligible)',
  CP_OPT_IN: 'Opt-In',
  CP_OPT_OUT: 'Opt-Out',
};

export const customPacingRequestedOptions = makeConfig<CustomPacingRequestedOption>(
  customPacingRequestedOptionDisplayNames
);

export function convertCustomPacingRequestedOption(apiValue: string): DisplayEnum<CustomPacingRequestedOption> {
  return convertToDisplayEnum(apiValue, customPacingRequestedOptions);
}
